import { Country } from '@/shared/models/view/country-viewmodel';
import { ICountry } from '@/shared/models/api/country-model';

export class CountryMapper {
    public mapCountry(country: ICountry): Country {
        return new Country(
            country.isoCode,
            country.name,
            country.nationality,
            country.countryCode
        )
    }
}